export enum MainBATabs {
    SCGPhysical = 'SCG Physical',
    CashPlanning = 'Cash',
}
